import omit from 'lodash/omit';

import { LinkData, NodeData } from 'src/containers/ProjectDiagram/types/model';
import { Project, ProjectsState } from 'src/store/state/projects';
import { ReduxState } from 'src/store/types';

/**
 *  Migration to remove `modified` flag from node and link data
 */
// prevState must be typed as `any` since it's an older version of the Redux State
export const v27 = (prevState: any): ReduxState => {
  const nextState = { ...prevState };

  if (nextState.projects) {
    nextState.projects = v27Projects(prevState.projects);
  }

  return nextState;
};

const v27Projects = (prevProjectsState: any): ProjectsState => {
  const projectsById: Record<string, Project> = {};

  Object.entries(
    prevProjectsState.projectsById as Record<string, Project>
  ).forEach(([projectId, project]) => {
    if (!project.diagram) {
      projectsById[projectId] = project;
      return;
    }

    projectsById[projectId] = {
      ...project,
      diagram: {
        ...project.diagram,
        model: {
          ...project.diagram.model,
          nodeDataArray: project.diagram.model.nodeDataArray.map(
            (data) => omit(data, 'modified') as NodeData
          ),
          linkDataArray: project.diagram.model.linkDataArray.map(
            (data) => omit(data, 'modified') as LinkData
          ),
        },
      },
    };
  });

  return { ...prevProjectsState, projectsById };
};
